module.exports = __webpack_public_path__ + "img/Stats Icon.890393a3.svg";